import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "box-carousel-inner" }
const _hoisted_2 = { class: "box-controller left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "carousel-inner" }
const _hoisted_6 = { class: "box-steps" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "box-controller right" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "box-indicators"
}
const _hoisted_12 = ["onClick"]

import { computed, ref, watch, onMounted, withDefaults, onBeforeUnmount, nextTick } from 'vue';
  import _ from 'lodash';
  import { Carousel } from 'bootstrap';

  export interface IProps {
    items: Array<any>;
    interval?: number | false;
    showIndicator?: boolean;
    chunkSize?: 1 | 2 | 3 | 4 | 6 | 12; // 可以被12整除的数字
    mobileChunkSize?: 1 | 2 | 3 | 4 | 6 | 12; // 可以被12整除的数字
    autoplay?: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    items: { default: () => [] },
    interval: { type: [Number, Boolean] },
    showIndicator: { type: Boolean, default: true },
    chunkSize: { default: 2 },
    mobileChunkSize: { default: 1 },
    autoplay: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { items: Array<any>, interval?: number | false, showIndicator: boolean, chunkSize: 1 | 2 | 3 | 4 | 6 | 12, mobileChunkSize: 1 | 2 | 3 | 4 | 6 | 12, autoplay: boolean }

  

  const root = ref();
  const current = ref(0);
  const renderRoot = ref(true);
  let carousel: Carousel;

  const currentChunkSize = ref(props.mobileChunkSize);

  const stepChunked = computed(() => {
    return _.chunk(props.items, currentChunkSize.value);
  });

  const on = {
    'slide.bs.carousel'(e: Carousel.Event) {
      current.value = e.to;
    }
  };

  const initCarousel = async () => {
    if (carousel) {
      carousel.dispose();
      // 重新渲染节点
      renderRoot.value = false;
      await nextTick();
      renderRoot.value = true;
      await nextTick();
    }
    current.value = 0;
    carousel = new Carousel(root.value, {
      interval: props.interval || false
    });
    if (props.autoplay) {
      carousel.cycle();
    }
  };

  const handleSlideTo = (to: number) => {
    carousel.to(to);
  };

  watch(
    [props.items.length, currentChunkSize],
    initCarousel
  );

  const calcChunkSize = _.debounce(() => {
    currentChunkSize.value = window.innerWidth < 768 ? props.mobileChunkSize : props.chunkSize;
  }, 500, { leading: true });

  onMounted(() => {
    initCarousel();
    calcChunkSize();
    window.addEventListener('resize', calcChunkSize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', calcChunkSize);
  });


return (_ctx: any,_cache: any) => {
  return (renderRoot.value)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        ref_key: "root",
        ref: root,
        class: "component-carousl-with-controller carousel slide"
      }, _toHandlers(on)), [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (current.value === 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "icon-arrow",
                  src: require('@/assets/icon/arrow-left-default.png')
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            (current.value > 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "icon-arrow item-controller",
                  src: require('@/assets/icon/arrow-left-active.png'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSlideTo(current.value - 1)))
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stepChunked), (group, groupIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: groupIndex,
                class: _normalizeClass(["carousel-item", { active: groupIndex === 0 }])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass([`col-${12/currentChunkSize.value}`])
                      }, [
                        _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(item)))
                      ], 2))
                    }), 128))
                  ])
                ])
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (current.value === _unref(stepChunked).length - 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "icon-arrow",
                  src: require('@/assets/icon/arrow-right-default.png')
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            (current.value < _unref(stepChunked).length - 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "icon-arrow item-controller",
                  src: require('@/assets/icon/arrow-right-active.png'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSlideTo(current.value + 1)))
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]),
        (__props.showIndicator && _unref(stepChunked).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stepChunked), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["indicator", { active: index === current.value }]),
                  type: "button",
                  onClick: ($event: any) => (handleSlideTo(index))
                }, null, 10, _hoisted_12))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 16))
    : _createCommentVNode("", true)
}
}

})